import { render, staticRenderFns } from "./TreeSider.vue?vue&type=template&id=77df5a0c&"
import script from "./TreeSider.vue?vue&type=script&lang=js&"
export * from "./TreeSider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports